export default __webpack_public_path__ + "static/media/Swimming Complex, Ambala3.765277c6.jpg";